<template>
   <svg fill="currentColor" viewBox="0 0 512 512">
      <path d="M80 96h352v32H80zm0 144h352v32H80zm0 144h352v32H80z" />
   </svg>
</template>
